import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Page() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setErr(false);
    setP(null);
    api.get(`/pages/${slug}`).then((r) => setP(r.data)).catch(() => setErr(true));
  }, [slug]);

  return (
    <div className="min-h-[65vh] bg-[#F5F7F6] px-4 pb-16 pt-[132px] sm:px-6 sm:pt-[140px]">
      <div className="mx-auto max-w-5xl">
        {err ? (
          <div className="rounded-2xl border border-[#DDE7E3] bg-white px-6 py-16 text-center shadow-sm" data-testid="page-404">
            <h1 className="font-serif text-3xl text-[#3F1723] sm:text-4xl">Page not found</h1>
            <p className="mt-3 text-[#60746D]">The page you're looking for doesn't exist yet.</p>
            <Link to="/" className="mt-6 inline-block font-medium text-[#176963] hover:underline">← Back to home</Link>
          </div>
        ) : !p ? (
          <div className="rounded-2xl border border-[#DDE7E3] bg-white px-6 py-16 text-center text-[#60746D] shadow-sm" data-testid="page-loading">
            Loading…
          </div>
        ) : (
          <>
            <SEO
              title={p.title}
              description={(p.html_content || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim().slice(0, 155)}
            />
            <div className="mb-6">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#176963]">Nityavastra · Information</p>
              <h1 className="mt-2 font-serif text-3xl leading-tight text-[#3F1723] sm:text-4xl">{p.title}</h1>
              <div className="mt-4 h-1 w-14 rounded-full bg-[#D4A03A]" />
            </div>
            <article className="rounded-2xl border border-[#DDE7E3] bg-white px-5 py-7 shadow-[0_8px_30px_rgba(30,63,56,0.05)] sm:px-9 sm:py-10" data-testid={`page-${slug}`}>
              <div
                className="prose prose-stone max-w-none text-[#43534E] prose-headings:font-serif prose-headings:text-[#3F1723] prose-a:text-[#176963] prose-a:underline-offset-2"
                data-testid="page-content"
                dangerouslySetInnerHTML={{ __html: p.html_content }}
              />
              <p className="mt-10 border-t border-[#E7EEEA] pt-5 text-xs text-[#788A84]">
                Last updated: {new Date(p.updated_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
              </p>
            </article>
          </>
        )}
      </div>
    </div>
  );
}
